import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Reportapi_unblockData } from "../../services/Report_api_unblock";

export default function AddReportagain(props) {
  const { updstate } = props;
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
    props.close(false);
  };
  const loGinHandle = () => {
      Reportapi_unblockData(props.id)
      .then(({ data }) => {
        updstate("Add Successfully");
        props.unblocked(props.id);        
      })
      .catch((err) => { 
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Unblock  "}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure to Unblock again ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button
            onClick={() => {
              handleClose();
              loGinHandle();
            }}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
